import { render, staticRenderFns } from "./PageHandle.vue?vue&type=template&id=8ca08904&scoped=true&"
import script from "./PageHandle.vue?vue&type=script&lang=js&"
export * from "./PageHandle.vue?vue&type=script&lang=js&"
import style0 from "./PageHandle.vue?vue&type=style&index=0&id=8ca08904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca08904",
  null
  
)

export default component.exports